<template>
  <v-container>
    <v-breadcrumbs
      class="px-0 py-2"
      :items="breadcrumbs"
    />
    <v-row>
      <v-col>
        <validation-observer ref="transportImportForm">
          <v-form>
            <v-card class="layout-custom-import rounded-card" elevation="1">
              <v-card-title>
                収集運搬業者情報のインポート
              </v-card-title>
              <v-card-subtitle>
                <p>ここでは指定する形式のCSVでインポートすることで収集運搬業者情報を一括登録することができます。</p>
              </v-card-subtitle>
              <v-divider />
              <v-card-text>
                <validation-provider
                  v-slot="{ errors }"
                  :rules="{ required: true, mimes: 'text/csv', megaFileSizeChecker: 10, fileChecker: true }"
                  class="requiredMark"
                  name="CSVファイル"
                >
                  <v-file-input
                    v-model="forms.file"
                    :error-messages="errors"
                    :show-size="1000"
                    accept="text/csv"
                    dense
                    hide-details="auto"
                    hint="ファイルサイズ10MBまで。最大3000件まで。"
                    label="CSVファイル"
                    outlined
                    persistent-hint
                    persistent-placeholder
                    required
                  />
                </validation-provider>
              </v-card-text>
              <v-card-actions>
                <v-spacer />
                <v-btn
                  color="primary"
                  @click="uploadButtonClickEvent"
                >
                  アップロード
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-form>
        </validation-observer>
      </v-col>
    </v-row>
    <csv-import-result import-type="transport" :do-reload="reloadComponent" />
  </v-container>
</template>

<script>
import CsvImportResult from '../../../components/_CsvImportResults'
import moment from 'moment'
import { mapActions } from 'vuex'


export default {
  name: 'TransportCsvImport',
  components: {
    CsvImportResult
  },
  mixins: [],
  props: {},
  data() {
    return {
      breadcrumbs: [
        { text: '収集運搬業者一覧', disabled: false, to: '/admin/masters/transports', exact: true },
        { text: '収集運搬業者情報のインポート', disabled: true, to: '' },
      ],
      forms: {
        file: null,
      },
      reloadComponent: null,
    }
  },
  computed: {},
  watch: {},
  created() {
  },
  methods: {
    ...mapActions('AdminSettingTransport', {
      upload: 'create',
    }),
    uploadButtonClickEvent () {
      let $self = this
      this.$refs.transportImportForm.validate().then((result) => {
        if(result){
          $self.sendRegistrationInformation()
        }
      })
    },
    sendRegistrationInformation(){
      const params = new FormData()
      params.append('file', this.forms.file)
      /**
       * @typedef content { Object }
       * @property has_error { Boolean }
       * @property errors { Array }
       */
      this.upload({params: params}).then(() => {
        this.reloadComponent = moment().unix()
        this.resetForm()
      })
    },
    resetForm () {
      this.$nextTick(() => this.$refs.transportImportForm.reset())
      Object.assign(this.$data.forms, this.$options.data().forms);
    }
  }
}
</script>

<style scoped lang="scss">

</style>
